import FooterBenefits from '../_patterns/01-components/footer-benefits/footer-benefits';
import Collapsible from '../_patterns/01-components/collapsible/collapsible';
import FooterNavigation from '../_patterns/01-components/footer-navigation/footer-navigation';
import ScNewsletterPopUp from '../_patterns/01-components/swarovski-club-nl-popup/swarovski-club-nl-popup';
import ServicesPopUp from '../_patterns/01-components/services-popup/services-popup';
import CmsGridComponent from '../_patterns/01-components/cms-components/cms-grid-component';
import ServiceContainerComponent from '../_patterns/01-components/services-container-component/services-container-component';

import { renderOutline } from './utils';

const init = () => {
  const footerBenefitsObj = new FooterBenefits();
  footerBenefitsObj.init();

  const collapsibleObj = new Collapsible();
  collapsibleObj.init();

  const footerNav = new FooterNavigation();
  footerNav.init();

  window.SwaScNewsletterPopUp = ScNewsletterPopUp;

  if (document.querySelector('.js-patternlab-page')) {
    const nlSwaPopup = new ScNewsletterPopUp();
    nlSwaPopup.init();
  }

  const servicesPopUpObj = document.querySelector('.js-swa-services-popup');
  if (servicesPopUpObj) {
    const servicesPopUp = new ServicesPopUp();
    servicesPopUp.init();
  }

  document
    .querySelectorAll('.js-service-container-component')
    .forEach(serviceContainerComponent => {
      new ServiceContainerComponent(serviceContainerComponent).init();
    });
  window.ServiceContainerComponentClass = ServiceContainerComponent;

  const gridComponentsAnimated = document.querySelectorAll('.swa-grid-component--animated');
  if (gridComponentsAnimated) {
    gridComponentsAnimated.forEach(gridComponentAnimated => {
      new CmsGridComponent(gridComponentAnimated).init();
    });
    window.CmsGridComponentClass = CmsGridComponent;
  }
};

if (document.querySelector('.js-swa-footer')) {
  init();

  // Show outline when navigating by TAB
  window.addEventListener('keyup', renderOutline);

  /* Makes PL example toggleable */
  if (document.querySelector('.js-patternlab-page')) {

    // Shows signup dialog after 5 seconds on homepage
    const homepage = document.querySelector('.js-patternlab-swa-home');
    if (homepage) {
      setTimeout(() => {window.overlayMessageDialogs['swa-signup-dialog'].show()}, 5000);
    }
  }
}
